import { render, staticRenderFns } from "./userForm.vue?vue&type=template&id=1c23b8d8&scoped=true&"
import script from "./userForm.vue?vue&type=script&lang=js&"
export * from "./userForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23b8d8",
  null
  
)

export default component.exports